import { imageUrl } from '@helpers/image';
import SvgMenuIcon from '@img/icons/menu.svg';
import SvgSearchIcon from '@img/icons/search.svg';
import SvgXIcon from '@img/icons/x.svg';
import Search from '@stories/Components/Search/Search';
import * as React from 'react';
import S from './Header.styles';
import MobileNavigation from './MobileNavigation/MobileNavigation';
import Navigation from './Navigation/Navigation';
import SecondaryNavigation from './SecondaryNavigation/SecondaryNavigation';
import { LinkButton } from '@stories/Components/Buttons/Button/Button';
const Header = (props) => {
    const { logo, items, secondaryItems, search, signIn } = props;
    const [searchOverlayActive, setSearchOverlayActive] = React.useState(false);
    const [mobileMenuActive, setMobileMenuActive] = React.useState(false);
    const [openModal, setOpenModal] = React.useState(false);
    return (React.createElement(React.Fragment, null,
        React.createElement(S.Container, null,
            React.createElement(S.TopContents, null,
                React.createElement(S.Inner, null,
                    React.createElement(SecondaryNavigation, { secondaryItems: secondaryItems, signIn: signIn, setOpenModal: () => setOpenModal(!openModal) }))),
            React.createElement(S.MainContents, { "data-reduce-search": items && items.length >= 5 },
                React.createElement(S.Inner, null,
                    React.createElement(S.LogoWrapper, { href: "/", "aria-label": "Link to the homepage" },
                        React.createElement(S.Logo, { fetchpriority: "high", loading: "eager", src: imageUrl(logo, { width: 226 }), width: 226, height: 44, alt: logo.altText ?? 'Mills & Reeve. Achieve more. Together.' })),
                    React.createElement(S.MobileButtons, null,
                        React.createElement(S.SearchButton, { "aria-pressed": searchOverlayActive, onClick: () => {
                                setMobileMenuActive(false);
                                setSearchOverlayActive(!searchOverlayActive);
                            } }, searchOverlayActive ? (React.createElement(React.Fragment, null,
                            React.createElement(SvgXIcon, null),
                            React.createElement("span", null, "Close"))) : (React.createElement(React.Fragment, null,
                            React.createElement(SvgSearchIcon, null),
                            React.createElement("span", null, search.buttonText)))),
                        React.createElement(S.MenuButton, { "aria-pressed": mobileMenuActive, onClick: () => {
                                setSearchOverlayActive(false);
                                setMobileMenuActive(!mobileMenuActive);
                            } }, mobileMenuActive ? (React.createElement(React.Fragment, null,
                            React.createElement(SvgXIcon, null),
                            React.createElement("span", null, "Close"))) : (React.createElement(React.Fragment, null,
                            React.createElement(SvgMenuIcon, null),
                            React.createElement("span", null, "Menu"))))),
                    React.createElement(Navigation, { items: items }),
                    React.createElement(S.SearchWrapper, { "data-mobile-overlay-visible": searchOverlayActive },
                        React.createElement(Search, { ...search, visible: searchOverlayActive })))),
            React.createElement(MobileNavigation, { activeId: "navigation-mobile", isActive: mobileMenuActive, items: items, secondaryItems: secondaryItems, signIn: props.signIn, setOpenModal: () => setOpenModal(!openModal) })),
        props.signIn && props.signIn.cards.length > 0 && (React.createElement(S.LoginModal, { "data-open-modal": openModal },
            React.createElement(S.LoginModalInner, null,
                React.createElement(S.CloseButton, { type: "button", onClick: () => setOpenModal(false) },
                    React.createElement(SvgXIcon, null),
                    React.createElement("span", null, "Close sign in modal button")),
                React.createElement(S.ModalGrid, null, props.signIn.cards.map((item, index) => (React.createElement(S.LoginCard, { key: index },
                    React.createElement(S.ContentArea, null,
                        item && item.title && React.createElement(S.CardTitle, null, item.title),
                        item && item.content && React.createElement(S.CardText, null, item.content)),
                    item?.cta ? (React.createElement(LinkButton, { buttonType: 'primary', buttonSize: "small", href: item.cta.url, target: item.cta.target }, item.cta.text)) : null)))))))));
};
export default Header;
